import { useMemo } from "react"
import { NUMERIC_OPERATORS } from "helpers/filters/filter-ons/numbers"
import type { RiskFilterOn } from "helpers/filters/filter-ons"
import { DataStatus, OK } from "helpers/data-statuses"

interface UseRiskFiltersParams {
  isOpPro: boolean
}

export function useRiskFilters({ isOpPro }: UseRiskFiltersParams): [RiskFilterOn[], DataStatus] {
  const filters = useMemo(() => {
    if (isOpPro) {
      return []
    }

    return [{
      label: "Risk",
      type: "risk" as const,
      options: [{
        label: "Total Risk",
        type: "risk" as const,
        dataType: "percent" as const,
        operators: NUMERIC_OPERATORS,
        value: "TOTAL",
      }, {
        label: "Factor Risk",
        type: "risk" as const,
        dataType: "percent" as const,
        operators: NUMERIC_OPERATORS,
        value: "VAR_DECOMP_FACTORS",
      }, {
        label: "Specific Risk",
        type: "risk" as const,
        dataType: "percent" as const,
        operators: NUMERIC_OPERATORS,
        value: "VAR_DECOMP_SPECIFIC",
      }],
    }]
  }, [isOpPro])

  return [filters, OK]
}
